import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { useAtom } from "jotai";

import { pdfRecordAtom } from "../../pages/ComparePage";

type Props = {
  addPrice: () => void;
  addComment: () => void;
};

export function AddPriceCommentModal({ addPrice, addComment }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isRecording] = useAtom(pdfRecordAtom);

  if (isRecording) return null;

  return (
    <>
      <Button fontSize="xs" mb={4} ml={10} onClick={onOpen} variant="link">
        Prijs of opmerking toevoegen
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="xs">
        <ModalOverlay />
        <ModalContent borderRadius={8}>
          <ModalHeader>Prijs of opmerking toevoegen</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Button
              mb={4}
              onClick={() => {
                addPrice();
                onClose();
              }}
              w="100%"
            >
              Prijs toevoegen
            </Button>
            <Button
              mb={4}
              onClick={() => {
                addComment();
                onClose();
              }}
              w="100%"
            >
              Opmerking toevoegen
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
